export * from './storage';
export * from './seo';
// export * from './env';
export const DOMAIN_ADS = 'https://web.api.adtimaserver.vn';
export const DOMAIN_NAME = 'baomoi.com';
export const DOMAIN_URL = 'https://baomoi.com';
export const PHOTO_URL = 'https://photo-baomoi.bmcdn.me'
export const ZALO_APP_ID = '4373017067085156544';

//URL
export const SUB_DOMAIN_URL = 'baomoi.net.vn'
export const LOG_URL = 'https://log.baomoi.com';
export const FB_FANPAGE = 'https://www.facebook.com/Baomoi';
export const PREFIX = 'bm';

export const SHARE_ZALO_BASEURL = 'zaloshareext://shareext';

export const GA_TRACKING_MOBILE_ID = 'UA-80204220-22';
export const GA_TRACKING_ZALO_ID = 'UA-115772620-7';

export const GA4_TRACKING_MOBILE_ID = 'G-1Q3Y03M60F';
export const GA4_TRACKING_ZALO_ID = 'G-2RK9KNBCJT';

export const ADMIN_IDS = ["1644839165182046770", "236433980", "264267461"];

export const SECTION_ID = {
    CONTENT: 5,
    CONTENT_LIST_TOP: 200,
    CONTENT_LIST_MORE: 6,
    CONTENT_FETCH_LIST: 7,
    CONTENT_BY_TOPIC: 80,
    CONTENT_BY_REGION: 90,
    CONTENT_EVENT: 122,
    CONTENT_TAG: 60,
    ADBANNER: 170,
    ADNATIVE: 30,
    ADTOPIC: 148,
    PUBLISHER: 10,
    SOCCER_HOME_NAV: 500,
    SOCCER_HOME_HEADER: 505,
    SOCCER_SCORE: 405,
    BANNER: 140,
    PODCAST: 20,
    PODCAST_BANNER: 22,
    ZSHORT: 142,
}

export const CONTENT_TYPE = {
    TEXT: 'text',
    IMAGE: 'image',
    PHOTO: 'photo',
    VIDEO: 'video',
    AUDIO: 'audio',
    AD_NATIVE: 'adNative',
    AD_BANNER: 'adBanner',
}

export type CONTENT_TYPE = 'text' | 'image' | 'photo' | 'video' | 'audio' | 'podcast' | 'adNative' | 'adBanner';

export const DEVICES = {
    DESKTOP: 'desktop' as DEVICES,
    TABLET: 'tablet' as DEVICES,
    MOBILE: 'mobile' as DEVICES,
}

export type DEVICES = 'desktop' | 'tablet' | 'mobile';

export const OS = {
    ANDROID: 'android' as OS,
    IOS: 'ios' as OS,
}

export type OS = 'android' | 'ios';

export const PLATFORM = {
    WEB: 1,
    WAP: 2,
    APP: 4,
    ZNEWS: 8,
}

export const PAGE_TYPE = {
    CONTENT_DETAIL: 'contentdetail',
    HOME: 'homepage'
}

export const CONTENT_TYPE_VALUE = {
    PHOTO: 1,
    VIDEO: 2,
    LIVE: 4096,
}

export const OBJECT_TYPE = {
    PUBLISHER: '3' as OBJECT_TYPE,
    CLUSTER: '5' as OBJECT_TYPE,
    TOPIC: '7' as OBJECT_TYPE,
}

export type OBJECT_TYPE = '3' | '5' | '7';


export const CONTENT_SUB_TYPE = {
    IMAGE_CAPTION: 'media-caption',
    AUTHOR: 'body-author',
    BODY_BLOCK: 'body-block',
    LIVE_BODY_BLOCK: 'live-body-block',
    TIME_STRING: 'time-string',
    TIME_CAPTION: 'time-caption',
}

export const VIEW_TYPE = {
    GRID: 'grid',
}

export const ERROR_CODE = {
    NOT_FOUND_ID: -108,
    REQUIRE_LOGIN: -801,
    CLIENT: -99998,
    UNKNOWN: -99999,
}

export const SUPPORT_VIDEO = {
    PROBABLY: 'probably',
    MAYBE: 'maybe',
    CANNOT: '',
}

export const SPEECH_MODE = {
    AUTO: 'auto' as SPEECH_MODE,
    MANUAL: 'manual' as SPEECH_MODE,
}

export type SPEECH_MODE = 'auto' | 'manual';

export const MODAL_ID = 'react-cool-portal';
export const MODAL_CLASS = 'bm-portal-modal';

export const EVENT = {
    PLAYER_PLAY: 'PLAYER_PLAY',
    SCRIPT_AD_LOAD_SUCCESS: 'SCRIPT_AD_LOAD_SUCCESS',
};


export const TOTAL_PAGINATION = 10;

export const PLACE_HOLDER = {
    IMAGE:
        'data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==',
    VIDEO:
        'https://baomoi-static.bmcdn.me/web/styles/img/player-default-03.png',
};

export const EXCLUDE_ERROR_CODES = [-801];

export const I_MINI_SIZE = 744;

export const TIME_SET_CONTENT = 5000;
